// Idea for an RxJS operator for backoff/retry lifted from.
// https://medium.com/angular-in-depth/retry-failed-http-requests-in-angular-f5959d486294
// backoff algorithm more or less a form of the exponential backoff algorithm with a randomized jitter

import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, retryWhen } from 'rxjs/operators';

export function retryWithBackoff(delayMs: number, maxRetries: number, maxBackoff: number) {
  let retries = 0;
  const jitter = Math.floor(Math.random() * delayMs);
  return (src: Observable<any>) =>
    src.pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap(error => {
            if (shouldRetry(error.status) && retries++ < maxRetries) {
              const backoffTime = jitter + Math.min(Math.pow(2, retries) * 1000, maxBackoff);
              return of(error).pipe(delay(backoffTime));
            }
            return throwError(error);
          })
        )
      )
    );
}

const shouldRetry = (status: number): boolean => {
  return status === 429 || status >= 500;
};
